import React from "react";
import {ActionRow, ActionRowButton, Icon} from "peggirkit";
import {TrashIcon} from "@heroicons/react/16/solid";
import {SetStateFn} from "@/utils/SetStateUtils";
import {FormattedMessage} from "react-intl";

type Props = {
    setShowDeleteLogsModal: SetStateFn<boolean>,
};

const SynchronizationLogsSectionHeadingActions = ({setShowDeleteLogsModal}: Props) => {
    return (
        <ActionRow>
            <ActionRowButton
                size={"xs"}
                color={"danger"}
                iconBefore={<Icon icon={TrashIcon}/>}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: () => setShowDeleteLogsModal(true),
                    },
                }}
            >
                <FormattedMessage id={"deleteOldLogs"}/>
            </ActionRowButton>
        </ActionRow>
    );
};

export default SynchronizationLogsSectionHeadingActions;